import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-back-to-top-button',
  templateUrl: './back-to-top-button.component.html',
})
export class BackToTopButtonComponent {
  shouldShowButton = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.shouldShowButton = window.scrollY > window.innerHeight / 3;
  }

  onTopClick(): void {
    window.scrollTo(0, 0);
  }
}
